import { Dispatch } from "redux";

import { Vehicle } from "../Interfaces/vehicle.type";
import { TOGGLE_DELIVERY_CHECKBOX } from "../redux/slices/bookDeliverySlice";

const selectForMultipleDelivery = (vehicle: Vehicle, dispatch: Dispatch) => {
  dispatch(
    TOGGLE_DELIVERY_CHECKBOX({
      vehicleIdentifier: vehicle.vehicleIdentifier,
      saleCode: vehicle.saleCode,
      vrm: vehicle.vrm,
      primaryVehicleDescription: vehicle.primaryVehicleDescription,
      bidAmount: vehicle.bidAmount,
      vatType: vehicle.vatType,
      delivery: vehicle.delivery,
      vehicle,
    })
  );
};

export default selectForMultipleDelivery;
